__turbopack_context__.v({
  "alsoLikeCard": "FilteredPrizeList-module__ym5Y6q__alsoLikeCard",
  "alsoLikeCategoryInfo": "FilteredPrizeList-module__ym5Y6q__alsoLikeCategoryInfo",
  "alsoLikeTextContainer": "FilteredPrizeList-module__ym5Y6q__alsoLikeTextContainer",
  "alsoLikeTierInfo": "FilteredPrizeList-module__ym5Y6q__alsoLikeTierInfo",
  "filteredPrizeList": "FilteredPrizeList-module__ym5Y6q__filteredPrizeList",
  "filteredPrizeListItem": "FilteredPrizeList-module__ym5Y6q__filteredPrizeListItem",
  "imageContainer": "FilteredPrizeList-module__ym5Y6q__imageContainer",
  "loadMoreContainer": "FilteredPrizeList-module__ym5Y6q__loadMoreContainer",
  "noResultsContainer": "FilteredPrizeList-module__ym5Y6q__noResultsContainer",
});
